import React, { useContext } from "react";
import CertificationNameLabelField from "module/certification/enrichedComponent/nameField/CertificationNameLabelField";
import CertificationContext from "module/certification/context/CertificationContext";
import { CertificationInterface } from "module/certification/types";

const CertificationNameFieldContainer: React.FC = () => {
  const { entity } = useContext(CertificationContext);
  const { name } = entity as CertificationInterface;

  return <CertificationNameLabelField {...{ name }} />;
};

export default React.memo(CertificationNameFieldContainer);
